<template>
	<div class="newsDetailsBox">

		<div class="max-newsDetailsBox">
			<div class="newsDetailsBox-banner">
				<div class="newsDetailsBox-banner-in">
					<div class="newsDetailsBox-banner-in-logo"></div>
				</div>
			</div>

			<div class="newsDetailsBox-nav">
				<div class="newsDetailsBox-nav-in"><span style="cursor: pointer;" @click="tapHome">首页</span> <span
						class="spana">></span> <span style="cursor: pointer;" @click="tapNews">新闻资讯</span> <span
						class="spana">></span> <span class="spanb">{{items.title}}</span></div>
			</div>

			<div class="newsDetailsBox-nav-nr">
				<div class="newsDetailsBox-nav-nr-in">
					<div class="newsDetailsBox-nav-nr-in-tit">{{items.title}}</div>
					<div class="newsDetailsBox-nav-nr-in-time">{{items.Fdate}}</div>
					<div class="newsDetailsBox-nav-nr-in-text" v-html="items.maincontent"></div>
				</div>
			</div>

			<div style="height:100px"></div>
			<PageBottom />
		</div>

		<div class="min-newsDetailsBox">
			<!-- <div class="min-newsDetailsBox-daohang" @click="tapMinfanhui">
				← 新闻列表
			</div> -->
			<div class="min-newsBox-top" @click="tapMinfanhui()">
				<div class="min-caseBox-top-icon"></div>
				新闻详情
			</div>

			<div class="min-newsDetailsBox-item-box">
				<div class="newsDetailsBox-nav-nr-in-tit">{{items.title}}</div>
				<div class="newsDetailsBox-nav-nr-in-time">{{items.Fdate}}</div>
				<div class="newsDetailsBox-nav-nr-in-text" v-html="items.maincontent"></div>
			</div>
		</div>

	</div>
</template>


<script>
	import PageBottom from '@/components/PageBottom.vue'
	export default {
		name: 'newsDetailsBox',
		components: {
			PageBottom
		},
		data() {
			return {
				items: {}
			}
		},
		mounted() {

			let path = this.$route.path;
			this.$store.commit('path', path);

			window.pageYOffset = 0;
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0

			let item = JSON.parse(decodeURIComponent(this.$route.params.item)); //解码
			// console.log(item)
			if (item) {
				this.items = item
			} else {
				this.$router.push({
					path: '/news'
				})
			}
		},
		methods: {
			//移动端点击返回
			tapMinfanhui() {
				this.$router.push({
					path: '/news'
				})
			},
			tapHome() {
				let path = '/';
				// console.log('path',path);
				this.$store.commit('path', path);

				this.$router.push({
					path: '/'
				})
			},
			tapNews() {
				let path = '/news';
				// console.log('path',path);
				this.$store.commit('path', path);

				this.$router.push({
					path: '/news'
				})
			}
		},
		beforeDestroy() { //组件销毁前
			localStorage.removeItem("newsItem"); //清除缓存
			// console.log('销毁了')
		}
	}
</script>

<style>
	.newsDetailsBox-banner {
		width: 100%;
		height: 480px;
		background-image: url(../assets/xinwenBg.jpg);
		background-size: 100% 100%;

	}

	.newsDetailsBox-banner-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		position: relative;
	}

	.newsDetailsBox-banner-in-logo {
		width: 275px;
		height: 70px;
		background-image: url(../assets/xinwenzixunTit.png);
		background-size: 100% 100%;
		position: absolute;
		top: 250px;
		left: 0;
	}

	.newsDetailsBox-nav {
		width: 100%;
		height: 50px;
		background: pink;
		margin-bottom: 80px;
		box-sizing: border-box;
		background: #f8f8f8;
	}

	.newsDetailsBox-nav-in {
		width: 1200px;
		height: 50px;
		/* background: tan; */
		margin: 0 auto;
		font-size: 16px;
		color: #353535;
		line-height: 50px;
		/* font-weight: bold; */
	}

	.spana {
		color: #353535;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.spanb {
		color: #999999;
	}

	.newsDetailsBox-nav-nr {
		width: 100%;
		height: auto;
		/* background: pink; */
	}

	.newsDetailsBox-nav-nr-in {
		width: 1200px;
		height: auto;
		/* background: tan; */
		margin: 0 auto;
	}

	.newsDetailsBox-nav-nr-in-tit {
		width: 100%;
		height: auto;
		font-size: 1.125rem;
		color: #353535;
		padding-bottom: 5px;
		box-sizing: border-box;
		margin-top: 0.625rem;
	}

	.newsDetailsBox-nav-nr-in-time {
		padding-bottom: 40px;
		box-sizing: border-box;
		width: 100%;
		font-size: 16px;
		line-height: 28px;
		color: #888888;
	}

	.newsDetailsBox-nav-nr-in-text {
		width: 100%;
		font-size: 16px;
		line-height: 28px;
		color: #666666;
	}

	.min-newsDetailsBox {
		display: none;
	}

	@media only screen and (max-width: 1200px) {
		.max-newsDetailsBox {
			display: none;
		}

		.min-newsDetailsBox {
			display: block;
			box-sizing: border-box;
			height: 100%;
			width: 100%;

		}

		.newsDetailsBox {
			/* padding: 1.25rem;
			box-sizing: border-box; */
			background: #ffffff;
			height: 100%;
			width: 100%;
		}

		.min-newsDetailsBox-daohang {
			padding-bottom: 1.25rem;
			box-sizing: border-box;
		}

		.min-newsDetailsBox-item-box {
			width: 100%;
			height: calc(100% - 49px - 44px);
			background: #ffffff;
			overflow-y: auto;
			overflow-x: hidden;
			padding: 0.625rem;
			padding-bottom: 0;
			box-sizing: border-box;
		}
	}
</style>
